'use client'

import Image from 'next/image'
import React, { useState } from 'react'

export default function GameImage({ url }: Readonly<{ url: string }>) {
    const [zoomedImage, setZoomedImage] = useState(null)

    const openZoomedImage = (url: any) => {
        setZoomedImage(url)
    }

    const closeZoomedImage = () => {
        setZoomedImage(null)
    }

    return (
        <>
            <Image
                src={url}
                alt="game logo"
                width={300}
                height={300}
                onClick={() => openZoomedImage(url)}
            />
            {zoomedImage && (
                <div
                    className="zoomed-image-container"
                    onClick={closeZoomedImage}
                >
                    <Image
                        src={zoomedImage}
                        alt="zoomed-image"
                        layout="fill"
                        objectFit="contain"
                    />
                </div>
            )}
        </>
    )
}
